<script>
export default {
  props: {
    xsmall: {
      type: Boolean,
      default: false,
    },
    xs: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      default: {
        size: 'medium',
        style: 'border',
        color: 'primary',
      },
    };
  },
  computed: {
    $_size() {
      if (this.medium || this.md) {
        return 'medium';
      }
      if (this.small || this.sm) {
        return 'small';
      }
      if (this.xsmall || this.xs) {
        return 'xsmall';
      }
      if (this.legoInput) {
        return this.legoInput.size;
      }
      return this.default.size;
    },
  },
};
</script>
<style lang="scss" scoped>
.lego-segment-wrapper {
  .lego-segment-button {
    &:nth-of-type(1) {
      &.lego-segment-button--small {
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
      }
      &.lego-segment-button--medium {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }
    }
    &:nth-last-of-type(1) {
      &.lego-segment-button--small {
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
      }
      &.lego-segment-button--medium {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }
    }
  }
}

.lego-segment-button--small {
  @include font($lego-button__font-size--small);
  min-width: 40px;
}
.lego-segment-button--medium {
  @include font($lego-button__font-size--medium);
  min-width: 60px;
}
</style>
